import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AdminService } from '../../../services/admin';
import { Addrembrs } from 'model/model.addrembrs';

@Component({
  selector: 'app-statistique-rembourse-traite',
  templateUrl: './statistique-rembourse-traite.component.html',
  styleUrls: ['./statistique-rembourse-traite.component.scss']
})
export class StatistiqueRembourseTraiteComponent implements OnInit {
  id: any;
  title:string=""
  mode_rembours_traiter:number;
  mode_montant : number;

  enregistrers : Array<Addrembrs>=new Array<Addrembrs>();
	date_debut : Date;
	date_fin : Date;
	enregistrer : Addrembrs=new Addrembrs();
  id_agent_actuel: any;
  loginuserCMSActuel: any;

  constructor(public activatedRoute: ActivatedRoute,public adminService: AdminService) { 
    this.id = activatedRoute.snapshot.params['id'];
    this.id_agent_actuel = this.adminService.getUserIMIscrit();
    if(this.id==1 ){
      this.title = "Statistique de remboursement traités";
      this.mode_rembours_traiter=1;
   }else if(this.id==2 ){
     this.title = "Statistique de remboursement ordonnancés";
     this.mode_rembours_traiter=2;
   }
  }

    ngOnInit() {
       this.loginuserCMSActuel = this.adminService.getLoginUseCMS();
      if(this.loginuserCMSActuel=="cms_daf"){
        this.mode_montant=1;
       }else{
        this.mode_montant=11;
       }
      this.getStatistiqueRemboursementTotal();
    }
  
  getStatistiqueRemboursementTotal(){
    this.adminService.getStatistiqueRemboursementTotal(this.enregistrer).subscribe(data=>{
        this.enregistrers=data;
        console.log("indreto izay o" + data)
    },err=>{
  
    });
  }

  getLibelleTypeRembourse(code){
    return this.adminService.getLibelleTypeRembourse(code);
  }
  
  }